<template>
  <div class="step_container">
     <a-form-model
      ref="entity_fifth_form"
      :model="fiveForm"
      :rules='rules'
      layout="horizontal"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
    <h1 class="step_title">POLITICALLY EXPOSED PERSON (“PEP") SELF-CERTIFICATION 政治敏感人物（“PEP”）自我认证</h1>
    <div class="step_question_container">
      <h2 class="step_question_title">
        Do you have: 您是否：
      </h2>
      <span class="claim_text">Do you, or an immediate family member, <i>hold (or did you or they hold at any time in the last 12 months) any of the following positions in any country? 您或直系亲属</i>是否在任何国家/地区担任（或者您在过去12个月内的任何时间持有）以下任何一个职位？</span>
      <div class="step_sub_title mt-10px">Immediate family member means:</div>
      <ul class="step_ul_style">
        <li>a spouse or partner (a person who is considered by relevant national law as equivalent to a spouse);</li>
        <li>a child, and a child’s spouse or partner; or</li>
        <li>a parent.</li>
      </ul>
      <div class="step_sub_title mt-10px">直系亲属为：</div>
      <ul class="step_ul_style">
<li>配偶或伴侣（相关国家法律认为与配偶等同的人）;</li>
        <li>儿童，儿童的配偶或伴侣;</li>
        <li>父母。</li>
        </ul>
      <a-form-model-item
            prop="entity_is_head_of_government"
            label="Head of state or head of a country or government  国家元首或政府首脑"
          >
            <a-radio-group
              :disabled='disabled'
              class="modify_antd_radio"
              @change="handleRadioSelect"
              v-model="fiveForm.entity_is_head_of_government"
              name="entity_is_head_of_government"
            >
              <a-radio :value="true"> Yes 是 </a-radio>
              <a-radio :value="false"> No 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
        <a-form-model-item
            prop="entity_is_government_minister"
            label="Government minister or equivalent senior politician 政府部长或同等高级政治家"
          >
            <a-radio-group
              :disabled='disabled'
              @change="handleRadioSelect"
              v-model="fiveForm.entity_is_government_minister"
              class="modify_antd_radio"
              name="entity_is_government_minister"
            >
              <a-radio :value="true"> Yes 是 </a-radio>
              <a-radio :value="false"> No 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
            prop="entity_is_court_judge"
            label="Supreme court judge or equivalent senior judge 最高法院法官或同等高级法官"
          >
            <a-radio-group
              :disabled='disabled'
              @change="handleRadioSelect"
              v-model="fiveForm.entity_is_court_judge"
              class="modify_antd_radio"
              name="entity_is_court_judge"
            >
              <a-radio :value="true"> Yes 是 </a-radio>
              <a-radio :value="false"> No 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
            prop="entity_is_governor_of_bank"
            label="Governor of a central bank or any other position that has comparable influence to the governor of the Reserve Bank of Australia/New Zealand 中央银行行长或任何其他与澳大利亚/新西兰储备银行行长具有可比影响力的职位"
          >
            <a-radio-group
              :disabled='disabled'
              @change="handleRadioSelect"
              v-model="fiveForm.entity_is_governor_of_bank"
              class="modify_antd_radio"
              name="entity_is_governor_of_bank"
            >
              <a-radio :value="true"> Yes 是 </a-radio>
              <a-radio :value="false"> No 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
            prop="entity_is_foreign_representative"
            label="Senior foreign representative, ambassador, or high commissioner 高级外国代表，大使或高级专员"
          >
            <a-radio-group
              :disabled='disabled'
              @change="handleRadioSelect"
              v-model="fiveForm.entity_is_foreign_representative"
              class="modify_antd_radio"
              name="entity_is_foreign_representative"
            >
              <a-radio :value="true"> Yes 是 </a-radio>
              <a-radio :value="false"> No 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
            prop="entity_is_armed_forces"
            label="High-ranking member of the armed forces 武装部队的高级成员"
          >
            <a-radio-group
              @change="handleRadioSelect"
              :disabled='disabled'
              v-model="fiveForm.entity_is_armed_forces"
              class="modify_antd_radio"
              name="entity_is_armed_forces"
            >
              <a-radio :value="true"> Yes 是 </a-radio>
              <a-radio :value="false"> No 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
            prop="entity_is_chief_executive"
            label="Board chair, chief executive, or chief financial officer of, or any other position that has comparable influence in, any state enterprise 任何国有企业的董事会主席，首席执行官或首席财务官，或任何其他具有类似影响力的职位"
          >
            <a-radio-group
              @change="handleRadioSelect"
              :disabled='disabled'
              v-model="fiveForm.entity_is_chief_executive"
              class="modify_antd_radio"
              name="entity_is_chief_executive"
            >
              <a-radio :value="true"> Yes 是 </a-radio>
              <a-radio :value="false"> No 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
            prop="entity_is_relative_with_entity"
            label="Joint beneficial ownership of a legal entity or arrangement (e.g. a trust), or any other close relationship, with a person in any of the positions above? 和上述任何职位的人一起拥有法律实体或安排（例如信托）的共同实益所有权或任何与他们有亲近、亲密关系"
          >
            <a-radio-group
              @change="handleRadioSelect"
              :disabled='disabled'
              v-model="fiveForm.entity_is_relative_with_entity"
              class="modify_antd_radio"
              name="entity_is_relative_with_entity"
            >
              <a-radio :value="true"> Yes 是 </a-radio>
              <a-radio :value="false"> No 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
            prop="entity_is_ownership_of_entity"
            label="Sole beneficial ownership of a legal entity or arrangement (e.g. a trust) that to exists for the benefit of a person in any of the positions above? 法律实体或安排（例如信托）的唯一受益所有权者，且为上述任何职位的利益而存在的人？"
          >
            <a-radio-group
              :disabled='disabled'
              @change="handleRadioSelect"
              v-model="fiveForm.entity_is_ownership_of_entity"
              class="modify_antd_radio"
              name="entity_is_ownership_of_entity"
            >
              <a-radio :value="true"> Yes 是 </a-radio>
              <a-radio :value="false"> No 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
    </div>
    <div class="step_question_container">
      <h2 class="step_question_title">
        CONFIRMATION 确认书
      </h2>
      <div class="step_sub_title mt-40px">I hereby agree and confirm that:</div>
      <ul class="step_ul_style">
        <li>My answer above is correct.</li>
        <li>If the answer to any category in the future becomes "yes" in the future, I will send a notification immediately.</li>
      </ul>
      <div class="step_sub_title mt-10px">我在此同意并确认：</div>
      <ul class="step_ul_style">
        <li>我上面的答案是正确的。</li>
        <li>如果以后任何类别的答案在将来变为“是”，我会立即发送通知。</li>
        </ul>
        <a-form-model-item
        prop="entity_confirm_checkbox"
        >
       <a-checkbox
        :disabled='disabled'
       class="antd_checkbox"
       name="entity_confirm_checkbox"
       :checked = entity_confirm_checkbox
       @change="handleCheckChange">
          Read & Consent 已读确认
        </a-checkbox>
      </a-form-model-item>
    </div>
    </a-form-model>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import rules from '@/assets/rules/entityFifthRules.js'

export default {
  data () {
    return {
      labelCol: { span: 24 },
      wrapperCol: { span: 24 }
    }
  },
  created () {
    this.rules = rules
  },
  beforeRouteLeave (to, from, next) {
    if (this.disabled) {
      next()
    } else {
      this.$refs.entity_fifth_form.validate(valid => {
        if (valid) {
          next()
        } else {
          next()
        }
      })
    }
  },
  methods: {

    handleCheckChange (e) {
      const { checked, name } = e.target
      this.ChangeFormAction({ content: name, value: checked })
    },
    handleRadioSelect (e) {
      const { name, value } = e.target
      this.ChangeFormAction({ content: name, value })
    },

    ...mapActions('entityStepFive', ['ChangeFormAction', 'ChangeObjectAction'])
  },
  computed: {
    fiveForm () {
      return this.$store.state.entityStepFive
    },
    ...mapGetters({
      disabled: 'login/getComplainceActive'
    }),
    ...mapState('entityStepFive', ['entity_is_head_of_government', 'entity_is_government_minister', 'entity_is_court_judge', 'entity_is_governor_of_bank', 'entity_is_foreign_representative', 'entity_is_armed_forces', 'entity_is_chief_executive', 'entity_is_relative_with_entity', 'entity_is_ownership_of_entity', 'entity_confirm_checkbox'])
  }
}
</script>

<style scoped>

.step_container {
  max-width: 940px;
  margin: 0 auto;
  background: rgb(248, 248, 248);
  padding: 0 1rem;

}

.step_small_title{
  font-size: 16px;
  font-weight: 300;
  text-align: center;
  margin-bottom: 20px;
}
.claim_text{
  font-weight: 300;
  font-size:17px;
  line-height: 28px;
}
.step_sub_title {
  margin-top: 20px;
  font-size: 17px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
}
.step_ul_style {
  list-style-type: inside;
  list-style-type: disc;
  padding-left: 20px;
  font-size: 16px;
  font-weight: 300;
}
.step_ul_style li {
  line-height: 24px;
}
.mt-10px{
  margin-top: 10px;
}
.mt-20px{
  margin-top: 20px;
}
.mt-40px{
  margin-top: 40px;
}
.modify_antd_radio >>> .ant-radio-inner{
  width: 26px;
  height: 26px;
}
.modify_antd_radio >>> .ant-radio-inner::after{
  width: 12px;
  left: 6px;
  top: 6px;
  height: 12px;
}

.ant-form >>> label{
  font-size: 15px;
}
.antd_checkbox >>> .ant-checkbox-wrapper {
  font-size: 15px;
}
.antd_checkbox >>> .ant-checkbox-inner{
  width: 30px;
  height: 30px;
}
.antd_checkbox >>> .ant-checkbox-inner::after{
  width: 9px;
  height: 18px;
}
</style>
